import {
  SingleTravelItinerary,
  MultiTravelItinerary,
  SeatedPassengers,
} from "@b2bportal/air-booking-api";
import { AirportMap, TripCategory } from "redmond";
import { BookingCompleteData, FlightBookingData } from "@capone/common";

const getTripTypeFromGeometry = (
  slices: (SingleTravelItinerary | MultiTravelItinerary)["slices"],
): FlightBookingData["tripType"] => {
  if (slices.length === 1) {
    return "oneWay";
  }

  if (slices.length === 2) {
    const [slice0, slice1] = slices;
    const slice0Origin = slice0.segments[0].origin.locationCode;
    const slice0Destination =
      slice0.segments[slice0.segments.length - 1].destination.locationCode;
    const slice1Origin = slice1.segments[0].origin.locationCode;
    const slice1Destination =
      slice1.segments[slice1.segments.length - 1].destination.locationCode;

    return slice0Origin === slice1Destination &&
      slice0Destination === slice1Origin
      ? "roundTrip"
      : "multiCity";
  }

  return "multiCity";
};

export const buildFlightBookingData = (
  travelItinerary: SingleTravelItinerary | MultiTravelItinerary,
  passengers: SeatedPassengers,
  airportMap?: AirportMap,
  tripCategory?: TripCategory,
): BookingCompleteData => {
  const slices = travelItinerary.slices;

  return {
    earnedRewards: { value: 0, currency: "Miles" },
    booking: {
      type: "flight",
      itineraryId: travelItinerary.itineraryId,
      tripType:
        tripCategory === TripCategory.MULTI_CITY
          ? "multiCity"
          : getTripTypeFromGeometry(slices),
      legs: slices.map((slice) => {
        const originCode = slice.segments[0].origin.locationCode;
        const destinationCode =
          slice.segments[slice.segments.length - 1].destination.locationCode;
        const originCity = airportMap?.[originCode]?.cityName;
        const destinationCity = airportMap?.[destinationCode]?.cityName;

        return {
          origin: originCode,
          destination: destinationCode,
          ...(originCity ? { originCity } : {}),
          ...(destinationCity ? { destinationCity } : {}),
          departureDateTime: slice.segments[0].scheduledDeparture,
          arrivalDateTime:
            slice.segments[slice.segments.length - 1].scheduledArrival,
        };
      }),
      passengerCount:
        (passengers.alone?.length ?? 0) +
        (passengers.withLapInfants?.length ?? 0),
    },
  };
};
